// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2KyIc","header":"ClearentDisclaimer_header__2ZkmY","inner":"ClearentDisclaimer_inner__2cbRM"};